import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

const items = [
  {
    quote:
      "Tony rebuilt my energy and my finances in the same year. For the first time they weren't fighting each other.",
    name: "Client A",
    role: "Coaching client",
  },
  {
    quote:
      "The whole-person approach is the difference. I finally sleep, and my relationship has never been steadier.",
    name: "Client B",
    role: "Coaching client",
  },
  {
    quote:
      "Practical, warm and relentlessly honest. The ebooks alone changed how I run my mornings.",
    name: "Client C",
    role: "Coaching client",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 lg:py-32 bg-brand-surface2/40 border-y border-brand-line">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <span className="overline">In their words</span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-brand-text mt-4 mb-3 max-w-2xl">
          Change people can feel.
        </h2>
        <p className="text-brand-dim text-sm mb-16">Client names withheld for privacy.</p>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.blockquote
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="rounded-3xl border border-brand-line bg-brand-surface p-8 flex flex-col"
            >
              <Quotes size={34} weight="fill" className="text-brand-gold/60 mb-6" />
              <p className="font-serif text-xl lg:text-2xl text-brand-text leading-snug flex-1">
                {t.quote}
              </p>
              <footer className="mt-8 pt-6 border-t border-brand-line">
                <p className="text-brand-text">{t.name}</p>
                <p className="overline mt-1">{t.role}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
